import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { useTheme } from '../providers/ThemeProvider';
export const KnowledgeBaseVirtualClassroom = () => {
  const {
    theme
  } = useTheme();
  const darkMode = theme === 'dark';
  const navigate = useNavigate();
  return <main className="pb-6" data-id="element-5379">
      <div className="max-w-4xl mx-auto px-4" data-id="element-5380">
        {/* Back button */}
        <button onClick={() => navigate('/help-support')} className={`flex items-center mb-6 ${darkMode ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'} transition-colors`} data-id="element-5381">
          <ArrowLeftIcon className="h-4 w-4 mr-2" data-id="element-5382" />
          Back to Help & Support
        </button>

        {/* Header */}
        <div className="mb-8" data-id="element-5383">
          <h1 className="text-2xl sm:text-3xl font-bold mb-2" data-id="element-5384">
            Virtual Classroom
          </h1>
        </div>

        {/* Content */}
        <div className={`rounded-lg ${darkMode ? 'bg-navy-800' : 'bg-white'} shadow-sm p-6 sm:p-8`} data-id="element-5385">
          <div className={`space-y-6 text-lg leading-relaxed ${darkMode ? 'text-gray-300' : 'text-gray-700'}`} data-id="element-5386">
            <p data-id="element-5387">
              Virtual Classroom features are planned for a future release of
              Maestro Connect.
            </p>

            <p data-id="element-5388">
              At this stage, Maestro Connect focuses on lesson organization,
              scheduling, and student management. Teachers can use their
              preferred video tools such as Zoom, Google Meet, or other video
              platforms for live lessons.
            </p>

            <p data-id="element-5389">
              This approach allows teachers to continue using tools they already
              trust, while Maestro Connect handles everything around the lesson.
            </p>
          </div>
        </div>
      </div>
    </main>;
};